module.exports = __webpack_public_path__ + "za.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/za.svg
// module id = 1151
// module chunks = 0